import { useLogout } from '@/presentation/hooks';
import { AccessDeniedError } from '@/domain/errors';
export const useErrorHandler = (callback) => {
    const logout = useLogout();
    return (error) => {
        if (error instanceof AccessDeniedError) {
            logout();
        }
        else {
            callback(error);
        }
    };
};
